import { useContext } from 'react';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Grid, Icon, LinearProgress } from '@mui/material';
import { useForm } from 'react-hook-form';
import { CustomPagination } from 'utils/functions';
import { dropDiaSemana } from 'utils/drops';
import { useDialog } from 'components/Modals';
import { GridContext } from 'contexts/GridContext';
import InputMask from 'components/InputMask';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import Title from '../Components/Title';
import localeText from 'utils/localeText';
import moment from 'moment';

const Horario = ({ drops, loading, pessoal = {}, onSubmit, onDelete }) => {
  const { openDialog } = useDialog();
  const horarios = pessoal?.Horarios ?? [];

  const Modal = ({ item }) => {
    const defaultValues = {
      rotina: 'PessoalHorario',
      id: item?.id,
      pessoal_id: pessoal?.id,
      dia: item?.dia || null,
      horario_id: item?.horario_id || null,
      inivalid: item?.inivalid || null,
      fimvalid: item?.fimvalid || null,
    };
    const { postLoading } = useContext(GridContext);
    const { control, handleSubmit } = useForm({ defaultValues });

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Title title="Identificação do Horário de Trabalho" disableMargin />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Dropdown
            name="dia"
            control={control}
            label="Dia da Semana"
            options={dropDiaSemana}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Dropdown
            label="Horário"
            name="horario_id"
            control={control}
            options={drops?.Horario}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputMask
            type="date"
            control={control}
            name="inivalid"
            label="Data de Início"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputMask
            type="date"
            control={control}
            name="fimvalid"
            label="Data de Término"
          />
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Button
            color="primary"
            loading={postLoading}
            variant="contained"
            onClick={handleSubmit(onSubmit)}
          >
            Salvar
          </Button>
        </Grid>
      </Grid>
    );
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Title
          title="Horários de Trabalho"
          disableMargin
          rightButton={
            <Button
              color="primary"
              variant="outlined"
              onClick={() => openDialog(<Modal />, 'Adicionar Horário')}
            >
              Adicionar
            </Button>
          }
        />
      </Grid>
      <Grid item xs={12}>
        <DataGrid
          rows={horarios}
          columns={[
            {
              field: 'dia',
              headerName: 'Dia da Semana',
              minWidth: 300,
              flex: 1,
              sortable: false,
            },
            {
              field: 'horario',
              headerName: 'Horário',
              width: 300,
              sortable: false,
            },
            {
              field: 'inivalid',
              headerName: 'Data de Início',
              width: 200,
              sortable: false,
              valueGetter: ({ value }) =>
                value && moment(value).format('DD/MM/YYYY'),
            },
            {
              field: 'fimvalid',
              headerName: 'Data de Término',
              width: 200,
              sortable: false,
              valueGetter: ({ value }) =>
                value && moment(value).format('DD/MM/YYYY'),
            },
            {
              field: 'actions',
              headerName: 'Ações',
              type: 'actions',
              width: 100,
              getActions: ({ row }) => [
                <GridActionsCellItem
                  icon={<Icon>edit</Icon>}
                  label="Editar"
                  onClick={() =>
                    openDialog(<Modal item={row} />, 'Editar Horário')
                  }
                />,
                <GridActionsCellItem
                  icon={<Icon>delete</Icon>}
                  label="Excluir"
                  onClick={() =>
                    onDelete({ rotina: 'PessoalHorario', id: row?.id })
                  }
                />,
              ],
            },
          ]}
          autoHeight
          pagination
          pageSize={10}
          density="compact"
          loading={loading}
          disableColumnMenu
          showCellRightBorder
          showColumnRightBorder
          disableSelectionOnClick
          localeText={localeText}
          getRowHeight={() => 'auto'}
          components={{
            Pagination: CustomPagination,
            LoadingOverlay: LinearProgress,
          }}
        />
      </Grid>
    </Grid>
  );
};

export default Horario;
